"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RadioGroupContext = require("./RadioGroupContext");
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _RadioGroup_css = _interopRequireDefault(require("./RadioGroup_css"));
/**
 * Wrapper component that allows RadioButtons to work with one another
 *
 * @FormGroupCompatible
 * @const RadioButton
 */
class RadioGroup extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _appendCss.default)("arc_rgrp", _RadioGroup_css.default);
  }
  render() {
    const {
      children,
      name,
      selectedValue,
      onChange
    } = this.props;
    const onChangeAddFormValue = (obj, event) => {
      if ("onFormValueChanged" in this.props) {
        this.props.onFormValueChanged(obj.label);
      }
      if (onChange) {
        onChange(obj, event);
      }
    };
    return /*#__PURE__*/_react.default.createElement(_RadioGroupContext.RadioGroupContext.Provider, {
      value: {
        name: name,
        selectedValue: selectedValue,
        onChange: onChangeAddFormValue
      }
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: "radiogroup__elem",
      role: "radiogroup"
    }, this.props.labelledby ? {
      "aria-labelledby": this.props.labelledby
    } : {}), children));
  }
}
RadioGroup.propTypes = {
  /** current selected value out of associated radio buttons */
  selectedValue: _propTypes.default.string,
  /** HTML name attribute */
  name: _propTypes.default.string,
  /** custom change event handler */
  onChange: _propTypes.default.func
};
var _default = exports.default = RadioGroup;